import {useCallback, useRef, useState } from 'react';

import { NavigateFunction } from 'react-router-dom';
import { Employee, TaskStatusCoordinateDetails } from 'types/interfaces';
import { generateGUID } from 'utils';

import { TaskService } from 'components/services/TaskService';

interface useTaskCardDialogsStateProps {
    navigate: NavigateFunction;
    taskId: number | string;
    employees: Employee[];
    isNewTask: any;
}


export function useTaskCardDialogsState(props: useTaskCardDialogsStateProps) {

  const { 
    navigate,
    taskId,
    employees,
    isNewTask
  } = props
  
  const [showDialog, setShowDialog] = useState(false);
  const handleConfirmationCancel = () => {
    setShowDialog(false);
  };
  const handleConfirmationContinue = () => {
    setShowDialog(false);
    navigate('/');
  };

  const handleDeleteConfirmation = async () => {
    await TaskService.deleteTask(taskId?.toString());
    window.opener?.postMessage(
      {
        type: 'DELETE_SUCCESS',
        payload: { detailToDelete: taskId }
      },
      '*'
    );
    setShowDeleteDialog(false);
    navigate('/');
  };

  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [assetCardKey, setAssetCardKey] = useState(generateGUID());
  const [dialogVisible, setDialogVisible] = useState<boolean>(false);
  const [assetData, setAssetData] = useState<any>(null);

  const assetCardRef = useRef<null | { handleCancel: () => void }>(null);
  const onHideAssetCard = () => {
    if (assetCardRef.current !== null) {
      assetCardRef.current.handleCancel();
    }
  };
  const closeAssetDialog = () => {
    setDialogVisible(false);
  };

  
  const [mapDialogVisible, setMapDialogVisible] = useState(false);
  const [mapDialogLoading, setMapDialogLoading] = useState(false);
  const [mapDialogError, setMapDialogError] = useState<string | null>(null);
  const [mapTaskDetails, setMapTaskDetails] =
    useState<TaskStatusCoordinateDetails | null>(null);


  const executorNodes =
    employees?.length > 0
      ? employees.map((executor) => ({
        key: executor.id.toString(),
        label: executor.fullName 
      }))
      : [];

  const isDetailIdValid =
    taskId &&
    (typeof taskId === 'string'
      ? taskId?.length > 0 && !isNewTask
      : taskId > 0);

  const openTaskMapDialog = useCallback(async () => {
    if (!isDetailIdValid) {
      return;
    }

    setMapDialogVisible(true);
    setMapDialogLoading(true);
    setMapDialogError(null);
    setMapTaskDetails(null);

    try {
      const response = await TaskService.getTaskStatusCoordinates(
        parseInt(taskId?.toString() ?? '0', 10)
      );
      if (response.data) {
        setMapTaskDetails(response.data);
      } else {
        setMapDialogError('Не удалось получить данные для карты.');
      }
    } catch (error) {
      console.error('Ошибка при получении данных карты:', error);
      setMapDialogError('Ошибка при загрузке данных карты.');
    } finally {
      setMapDialogLoading(false);
    }
  }, [isDetailIdValid, taskId]);

  const closeTaskMapDialog = () => {
    setMapDialogVisible(false);
    setMapDialogError(null);
    setMapTaskDetails(null);
  };

  return {
    showDialog,
    setShowDialog,
    handleConfirmationCancel,
    handleConfirmationContinue,
    
    showDeleteDialog,
    setShowDeleteDialog,
    
    assetCardKey,
    setAssetCardKey,
    dialogVisible,
    setDialogVisible,
    assetData,
    setAssetData,
    assetCardRef,
    onHideAssetCard,
    closeAssetDialog,
    
    mapDialogVisible,
    setMapDialogVisible,
    mapDialogLoading,
    setMapDialogLoading,
    mapDialogError,
    setMapDialogError,
    mapTaskDetails,
    setMapTaskDetails,
    handleDeleteConfirmation,

    executorNodes,
    isDetailIdValid,
    openTaskMapDialog,
    closeTaskMapDialog
  };
}
